import { Button } from '@/components/ui/button'
import { formatDateTime } from '@/lib/format'
import { messages } from '@/lib/messages'
import { useReportVersions, useRestoreVersion, type BiReport } from '@/services/bi/reports'

const t = messages.documents.editor.versions

/** Sürüm geçmişi ve "bu sürüme dön" (eski içerik YENİ sürüm olarak geri yazılır). */
export function VersionsPanel({
  reportId,
  canEdit,
  currentVersion,
  dirty,
  onRestored,
}: {
  reportId: string
  canEdit: boolean
  currentVersion: number
  dirty: boolean
  onRestored: (report: BiReport) => void
}) {
  const versions = useReportVersions(reportId, canEdit)
  const restore = useRestoreVersion(reportId)

  if (!canEdit) return <p className="text-muted-foreground text-sm">{t.readOnly}</p>
  if (versions.isLoading) return <p className="text-muted-foreground text-sm">{t.loading}</p>
  if (versions.isError)
    return (
      <p role="alert" className="text-destructive text-sm">
        {messages.states.errorTitle}
      </p>
    )
  const items = [...(versions.data ?? [])].sort((a, b) => b.version - a.version)
  if (items.length === 0) return <p className="text-muted-foreground text-sm">{t.empty}</p>

  return (
    <section aria-label={t.title} className="flex flex-col gap-2">
      <h3 className="text-sm font-medium">{t.title}</h3>
      <ol className="flex flex-col gap-1.5">
        {items.map((item) => {
          const current = item.version === currentVersion
          return (
            <li
              key={item.version}
              className="border-input flex items-center gap-2 rounded-sm border px-2 py-1.5 text-sm"
            >
              <span className="flex flex-1 flex-col">
                <span className="font-medium">
                  {t.label(item.version)}
                  {current && (
                    <span className="text-muted-foreground font-normal"> · {t.current}</span>
                  )}
                </span>
                <span className="text-muted-foreground text-xs">
                  {formatDateTime(item.created_at)}
                </span>
              </span>
              {!current && (
                <Button
                  size="sm"
                  variant="outline"
                  disabled={restore.isPending}
                  onClick={() => {
                    if (dirty && !window.confirm(t.restoreConfirm(item.version))) return
                    restore.mutate(item.version, { onSuccess: onRestored })
                  }}
                >
                  {t.restore}
                </Button>
              )}
            </li>
          )
        })}
      </ol>
    </section>
  )
}
